import TourInitializer from './TourInitializer';

export default TourInitializer;
